<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create audio</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Years</label>
                  <div class="col-md-10">
                    <input
                      id="date"
                      v-model="entity.date"
                      type="text"
                      placeholder="Enter date years"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Audio file *</label>
                  <div class="col-md-10">
                    <FileUploader
                      ref="fileUploader"
                      v-model="audioFile"
                      check-type="media_audio"
                      path-prefix="aud"
                      :dropzone-options="dropzoneOptions"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Album</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.album"
                      :default-options="defaultOptions.audioAlbums"
                      :search-function="albumSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Transcription</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.transcription"
                      :default-options="defaultOptions.docs"
                      :search-function="transcriptionSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Audio has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
import FileUploader from '@/global/components/FileUploader/Index';
import SelectRemote from '@/global/components/SelectRemote';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import config from '../../../config';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'AudioNew',

  components: {
    FileUploader,
    'select-remote': SelectRemote,
    referencer: Referencer,
    terms: Terms,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests],

  data() {
    return {
      audioFile: null,
      entity: {
        title: null,
        date: '',
        body: null,
        summary: null,
        mediaFile: null,
        album: null,
        transcription: null,
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: 0,
        featuredBody: '',
      },
      dropzoneOptions: {
        url: '/',
        maxFiles: 1,
        maxFilesize: 100,
        acceptedFiles: 'audio/*',
        autoProcessQueue: false,
        addRemoveLinks: true,
        accept: (file, done) => {
          const filesArray = _.filter(this.$refs.fileUploader.$refs.dropzone.files, item => item.status !== 'error');
          if (filesArray.length > 1) {
            done('You can upload 1 file maximum');
          }
        },
      },
    };
  },

  mounted() {
    this.$_getDefaultAlbums();
    this.$_getDefaultDocuments();
  },

  methods: {
    albumSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/audio-albums?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    transcriptionSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/documents?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    isEntityValid() {
      const { audioFile } = this;
      const filelds = [
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
      ];
      if (audioFile.uploadType === 'url') {
        filelds.push({ name: 'Audio file', value: audioFile.fileLink, type: 'required' },);
      } else {
        filelds.push({ name: 'Audio file', value: audioFile.file, type: 'required' },);
      }
      return this.$_validate(filelds);
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('date', this.entity.date);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.audioFile.uploadType === 'file') {
        // postFormData.append('mediaFile', this.audioFile.file);
        postFormData.append('chunkedFile', true);
      } else {
        postFormData.append('selectel_file_url', this.audioFile.fileLink);
      }
      if (this.entity.album) postFormData.append('album_id', +this.entity.album.id);
      if (this.entity.transcription) postFormData.append('transcription', +this.entity.transcription.id);
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/audio`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { file, uploadType } = this.audioFile;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { acceptedFiles } = this.dropzoneOptions;
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (file && uploadType === 'file') {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
        }
        this.$parent.getSource();
        window.location.hash = `#/admin/content/media_audio/edit/${response.data.id}`;
      }, (error) => {
        console.error('Error in audio create request', error);
        this.$_errorSave(error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?3e3f0590